import React, { useState, useEffect } from "react";
import VideoModal from "../components/VideoModal";
import "../styles/Pages.css";
import "../styles/HariParamrut.css";

const YOUTUBE_API_KEY = "AIzaSyCfKPm1GW8SwqE9AZM9p17fOYPPkZtNWIY";
const PLAYLIST_ID = "PLwDKIQbzxGjJb-cZ7m8nILycEhKGJQcJ0";

function HariParamrutFour() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllPlaylistVideos = async () => {
      try {
        setLoading(true);
        const allVideos = [];
        let pageToken = "";

        do {
          const url =
            `https://www.googleapis.com/youtube/v3/playlistItems` +
            `?part=snippet` +
            `&playlistId=${PLAYLIST_ID}` +
            `&maxResults=50` +
            `&key=${YOUTUBE_API_KEY}` +
            (pageToken ? `&pageToken=${pageToken}` : "");

          const response = await fetch(url);
          if (!response.ok) {
            throw new Error("Failed to fetch playlist videos");
          }
          const data = await response.json();

          data.items.forEach((item) => {
            const videoId = item.snippet?.resourceId?.videoId;
            const title = item.snippet?.title;
            if (
              videoId &&
              title &&
              title !== "Deleted video" &&
              title !== "Private video"
            ) {
              allVideos.push({ id: videoId, title });
            }
          });

          pageToken = data.nextPageToken || "";
        } while (pageToken);

        setVideos(allVideos);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching playlist videos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllPlaylistVideos();
  }, []);

  const openVideoModal = (videoId, title) => {
    setSelectedVideoId(videoId);
    setSelectedVideoTitle(title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideoId(null);
    setSelectedVideoTitle(null);
  };

  return (
    <main className="page-content pravachan-page">
      <section className="page-header">
        <h1 className="section-title">
          Hari Paramrut Two
          {!loading && !error && (
            <span
              style={{ fontSize: "1rem", marginLeft: "12px", color: "#888" }}
            >
              ({videos.length})
            </span>
          )}
        </h1>
        <p className="header-subtitle">
          Guruhari P.P. Hariprasad Swamishri Paravani
        </p>
      </section>

      <section className="page-body">
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading videos...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <p>Error loading videos: {error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        )}

        {!loading && !error && (
          <div className="video-grid">
            {videos.map((video, index) => (
              <div
                key={index}
                className="video-card"
                onClick={() => openVideoModal(video.id, video.title)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === "Enter") openVideoModal(video.id, video.title);
                }}
              >
                <div className="video-thumbnail">
                  <img
                    src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                    alt={video.title}
                  />
                  <div className="play-overlay">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
                <div className="video-info">
                  <h3>{video.title}</h3>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {isModalOpen && (
        <VideoModal
          videoId={selectedVideoId}
          title={selectedVideoTitle}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}
    </main>
  );
}

export default HariParamrutFour;
